export default (pollState) => {
  if (pollState === 'retries_exceeded') {
    throw new Error('Polling retries exceeded');
  }
};
